module.exports = __webpack_public_path__ + "img/Layer-Photos.09930179.png";